export const EXPORT_SAP_FILE_MODAL = "exportSapFileModal" as const;
export const IMPORT_SAP_FILE_MODAL = "importSapFileModal" as const;
